import ApiProvider from "./ApiProvider"
import Booking from "../models/Booking"
import { Source } from "../models/Source"
import Venue from '../models/Venue'

export default abstract class AvailabilityProvider extends ApiProvider {
    apiEndpoint: string = 'booking-availability'
    booking: Booking

    constructor (booking: Booking) {
        super()

        this.booking = booking
    }

    _buildUrl (venue: Venue, endpoint: string | null = null): string {
        let url = [
            this.baseUrl,
            'venues',
            venue.id,
            this.apiEndpoint
        ].join('/')

        if(endpoint && endpoint.length) {
            url += '/' + endpoint;
        }

        return url
    }
}



// WEBPACK FOOTER //
// ./src/services/AvailabilityProvider.ts